export const TRANSLATIONS_PT = {
    welcome: 'Em breve',
    search: 'Buscar',
    stores: 'Lojas',
    back: 'Voltar',
    next: 'Próximo',
    review: 'Revisar',
    filter: 'Filtro',
    country: 'País',
    socialReason: 'Razão social',
    countries: {
        ar: 'Argentina',
        br: 'Brasil',
        cl: 'Chile',
        co: 'Colômbia',
        cr: 'Costa Rica',
        ec: 'Equador',
        mx: 'México',
        pe: 'Peru',
        uy: 'Uruguai',
    },
    menuGenerator: {
        title: 'Gerador de cardápio',
        breadcrumbItems: { brandDevelopment: 'Brand Development', menuGenerator: 'Gerador de cardápio' },
        notAllowed: 'não está habilitado para usar essa funcionalidade.',
        tabs: {
            generated: 'Cardápios Gerados',
            top10: 'Top 10',
        },
        table: {
            generated: {
                header: {
                    generated: 'Você gerou {{number}} cardápios',
                    initial: 'Você ainda não gerou cardápios',
                },
                ia: {
                    pending: 'Gerando',
                    error: 'Falha na geração',
                },
                columns: {
                    name: 'Nome do Restaurante',
                    createdAt: 'Criado em',
                    actions: 'Ações',
                },
                actions: {
                    search: 'Buscar',
                    generate: 'Gerar novo cardápio',
                    copyLink: 'Copiar link',
                    view: 'Ver no Google Sheets',
                    delete: 'Eliminar',
                },
            },
            top10: {
                stats: {
                    label: {
                        rank: 'Sua classificação',
                        totalMenus: 'Cardápios gerados',
                        totalMenusToday: 'Cardápios gerados hoje',
                    },
                    values: {
                        rank: '{{rank}}º lugar',
                        withoutRank: 'Sem classificação',
                        totalMenus: '{{totalMenus}} cardápios',
                        totalMenusToday: '{{totalMenusToday}} cardápios',
                    },
                },
                columns: {
                    rank: 'Faixa',
                    name: 'Nome',
                    country: 'País',
                    lastMenuUpdated: 'Último cardápio atualizado',
                    totalMenus: 'Cardápios gerados',
                },
            },
            pagination: {
                rangeSeparatorText: 'de',
                rowsPerPageText: 'Linhas por página',
                selectAllRowsItemText: 'Todos',
            },
            notification: {
                error: 'Ocorreu um problema ao carregar os dados. Tente novamente.',
            },
        },
        sidebar: {
            form: {
                title: 'Gerar Cardápio',
                restaurantName: 'Nome do Restaurante',
                leadId: 'Lead ID',
                country: 'País',
                fileInput: {
                    label: 'Arraste o cardápio aqui ou',
                    dropLabel: 'Solte seus arquivos aqui',
                    successLabel: 'Carregado com sucesso',
                    select: 'Selecionar arquivos',
                    replace: 'Substituir arquivos',
                    multiple: {
                        fileName: 'arquivos_combinados',
                        success: 'Os arquivos foram combinados em um PDF, você pode visualizá-lo <a>aqui</a>',
                        error: 'Erro ao combinar arquivos',
                    },
                    rules: {
                        label: {
                            formats: 'Formatos',
                            maxSize: 'Tamanho máximo',
                        },
                        invalid: {
                            formats: 'Este arquivo não é um formato compatível.',
                            maxSize: 'Este arquivo é muito grande.',
                        },
                    },
                },
                submit: 'Gerar',
                notification: {
                    success: 'Cardápio "{{restaurantName}}" gerado corretamente',
                    error: 'A geração do cardápio "{{restaurantName}}" falhou. Por favor, tente novamente.',
                },
            },
        },
    },
    commercialProcesses: {
        title: 'Processos Comerciais',
        startProcess: 'Iniciar Processo',
        filter: {
            state: 'Estado',
            processName: 'Processo Comercial',
            email: 'Email Agente',
        },
        state: {
            active: 'Ativo',
            completed: 'Completado',
            rejected: 'Rejeitado',
            review: 'Em revisão',
            canceled: 'Cancelado',
            error: 'Erro',
        },
        table: {
            columns: {
                country: 'País',
                process: 'Processo Comercial',
                agent: 'Agente',
                state: 'Estado',
                startDate: 'Data de criação',
                updateDate: 'Data de atualização',
                action: 'Ação',
            },
            empty: {
                label: 'Não há processos comerciais',
                description: 'Não foram encontrados processos comerciais para os filtros aplicados.',
            },
            error: {
                label: 'Erro ao carregar processos',
                description: 'Ocorreu um erro ao carregar os processos comerciais. Tente novamente.',
            },
        },
    },
    commercialProcessesFinder: {
        title: 'Buscador',
        idType: 'Tipo de Documento',
        id: 'Documento',
        searchTitle: 'Buscar razão social',
        searchDescription: 'Insira o tipo e número de documento da razão social para ver os processos comerciais disponíveis.',
        processesTitle: 'Processos Comerciais',
        duration: 'Duração',
        minutes: 'minutos',
        documents: 'Documentos',
        startProcess: 'Iniciar Processo',
        processNotAvailable: 'Processo não disponível',
        found: 'Encontrado',
        notification: {
            error: 'Ocorreu um problema ao carregar os dados. Tente novamente.',
            notFound: 'Não foram encontrados processos comerciais disponíveis para o documento inserido.',
        },
        reasons: {
            BUSINESS_NO_PAYMENT_REFERENCE: 'Não foi encontrada referência de pagamento',
            BUSINESS_ALREADY_IN_PROCESS: 'O aliado já possui um processo comercial em andamento',
            BUSINESS_MISSING_MANDATORY_DETAILS: 'Business não tem todos os dados em pagos (legalrepresentativeemail, contactmail, billingmail, legalrepresentativename, legalrepresentativelastname, is_person)',
        },
        processes: {
            'bank-account-change': {
                title: 'Alteração de conta bancária',
                description: 'Atualiza a informação da conta bancária onde o aliado receberá os pagamentos de suas vendas',
            },
            'social-reason-change': {
                title: 'Alteração de razão social',
                description: 'Cede o contrato atual da razão social ativa para outra',
            },
            'fiscal-information-change': {
                title: 'Alteração de informação fiscal',
                description: 'Atualiza a informação fiscal do aliado registrado em rappi',
            },
            'brand-name-change': {
                title: 'Alteração de nome comercial',
                description: 'Atualiza o nome da marca registrada em rappi',
            },
            'legal-representative-change': {
                title: 'Alteração de representante legal',
                description: 'Atualiza a informação do representante legal autorizado para a empresa ou negócio',
            },
        },
    },
    commercialProcess: {
        titleNew: 'Novo Processo Comercial',
        title: 'Processo Comercial',
        exitConfirmation: 'Tem certeza que deseja sair? Todos os dados do processo serão perdidos.',
        rejectionReason: 'Motivo do rejeição',
        breadcrumb: {
            processes: 'Processos Comerciais',
            process: 'Processo Comercial',
        },
        modal: {
            title: 'Tem certeza de que deseja enviar essas alterações?',
            body: 'Lembre-se de que você pode voltar a qualquer etapa anterior para modificar as informações sem perder o progresso realizado.',
            buttons: {
                cancel: 'Cancelar',
                continue: 'Continuar',
            },
        },
        notification: {
            getContext: {
                error: 'Ocorreu um problema ao obter os dados do processo. Tente novamente.',
                notFound: 'Não foram encontrados dados do processo.',
            },
            create: {
                success: 'Processo criado corretamente',
                error: 'Ocorreu um problema ao criar o processo. Tente novamente.',
            },
            update: {
                success: 'Processo atualizado corretamente',
                error: 'Ocorreu um problema ao atualizar o processo. Tente novamente.',
            },
        },
        steps: {
            'select-bank-account': {
                title: 'Seleção de Conta Bancária',
                description: 'Seleciona a conta bancária cujos dados deseja modificar',
                labels: {
                    bank: 'Banco',
                },
            },
            'bank-account-modification': {
                title: 'Formulário de Conta Bancária',
                description: 'Por favor, insira os seguintes dados para continuar com o processo.',
                scrapingData: 'Identificamos os seguintes dados no certificado bancário',
            },
            'social-reason-modification': {
                title: 'Formulário de Razão Social',
                description: 'Por favor, insira os seguintes dados para continuar com o processo.',
                scrapingData: 'Identificamos os seguintes dados na razão social',
            },
            confirm: {
                title: 'Confirmação de Dados',
                description: 'Por favor, confirme os seguintes dados para criar o processo',
                reviewTitle: 'Revisão do processo!',
                lastStepTitle: 'Última etapa do processo!',
                reviewDescription: 'Você está visualizando as informações deste processo comercial no modo somente leitura. Não é possível fazer alterações, mas você pode revisar todos os dados e documentos associados.',
                lastStepDescription: 'Revise cuidadosamente todas as informações antes de continuar. Você pode voltar a qualquer etapa anterior para modificar os dados sem perder o progresso realizado.',
                close: 'Fechar',
                finish: 'Finalizar processo',
            },
            documents: {
                title: 'Documentos',
                description: 'Envie os seguintes documentos para continuar com o processo. Certifique-se de que os arquivos sejam legíveis.',
                labels: {
                    BANK_ACCOUNT: 'Certificado Bancário',
                    SOCIAL_REASON: 'Razão Social',
                },
            },
        },
    },
};
